import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Layout from './components/Layout/Layout';
import PodManagement from './pages/PodManagement/PodManagement';
import PodForm from './pages/PodManagement/PodForm';
import EpicPlanner from './pages/EpicPlanner/EpicPlanner';
import EpicForm from './pages/EpicPlanner/EpicForm';
import WorkstreamForm from './pages/EpicPlanner/WorkstreamForm';
import WorkstreamForecaster from './pages/WorkstreamForecaster/WorkstreamForecaster';
import SprintEditView from './pages/EpicPlanner/SprintEditView';
import WorkstreamSprintPlanner from './pages/EpicPlanner/WorkstreamSprintPlanner';
import Backlog from './pages/Backlog/Backlog';
import StoryForm from './pages/Backlog/StoryForm';
import Documentation from './pages/Documentation/Documentation';
import Settings from './pages/Settings/Settings';

const App: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Layout>
        <Routes>
          <Route path="/" element={<Navigate to="/epic-planner" replace />} />
          <Route path="/pod-management" element={<PodManagement />} />
          <Route path="/pod-management/new" element={<PodForm />} />
          <Route path="/pod-management/:podId/edit" element={<PodForm />} />
          <Route path="/epic-planner" element={<EpicPlanner />} />
          <Route path="/epic-planner/new" element={<EpicForm />} />
          <Route path="/epic-planner/:epicId/edit" element={<EpicForm />} />
          <Route path="/epic-planner/workstreams/new" element={<WorkstreamForm />} />
          <Route path="/epic-planner/workstreams/:workstreamId/edit" element={<WorkstreamForm />} />
          <Route path="/epic-planner/workstreams/:workstreamId/sprints/:sprintId/edit" element={<SprintEditView />} />
          <Route path="/epic-planner/workstreams/:workstreamId/sprint-planner" element={<WorkstreamSprintPlanner />} />
          <Route path="/workstream-forecaster" element={<WorkstreamForecaster />} />
          <Route path="/backlog" element={<Backlog />} />
          <Route path="/backlog/stories/new" element={<StoryForm />} />
          <Route path="/backlog/stories/:storyId/edit" element={<StoryForm />} />
          <Route path="/backlog/epics/new" element={<EpicForm />} />
          <Route path="/backlog/epics/:epicId/edit" element={<EpicForm />} />
          <Route path="/documentation" element={<Documentation />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </Layout>
    </Box>
  );
};

export default App;
